import { Flex, Heading, Link } from '@chakra-ui/react';
import { SystemProps } from '@chakra-ui/styled-system';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Link as ReactLink } from 'react-router-dom';

export interface GridHeadingTrailingLink {
  path: string;
  text: string;
  fontWeight?: SystemProps['fontWeight'];
}

interface Props extends PropsWithChildren {
  trailingNode?: ReactNode;
  trailingLink?: GridHeadingTrailingLink;
}

const GridHeading: FC<Props> = ({ children, trailingNode, trailingLink }) => {
  const trailing =
    trailingNode ??
    (trailingLink && (
      <Link
        color={Color.Primary500}
        as={ReactLink}
        to={trailingLink.path}
        fontWeight={trailingLink.fontWeight}
      >
        {trailingLink.text}
      </Link>
    ));

  return (
    <Flex
      mb="10px"
      justifyContent="space-between"
      alignItems="center"
      px="20px"
      w="100%"
    >
      <Heading fontSize={FontSize.xl}>{children}</Heading>
      {trailing}
    </Flex>
  );
};

export default GridHeading;
